import React from 'react';
import OfferManager from '../components/OfferManager';

const OfferManagerApp = (props) => <OfferManager {...props} />;

export default OfferManagerApp;
